const FORM_FIELD_TYPES = {
  TEXT: 'text',
  SELECTLIST: 'selectList',
  DATE: 'date',
  CHECKBOX: 'checkbox',
  FILE: 'file',
  TEL: 'tel',
}

export default FORM_FIELD_TYPES;